<script setup lang="ts">
import type { ANavigationItemInterface, ANavigationProductsProperties, ANavigationProfileInterface } from '@atabix/vue-ui'
import { ANavigation } from '@atabix/vue-ui'
import { LogOutIcon, SandwichIcon, SettingsIcon, SmartphoneIcon } from 'lucide-vue-next'
import { computed, h, markRaw } from 'vue'
import { useI18n } from 'vue-i18n'
import { RouterView, useRouter } from 'vue-router'

import { useAuthDriver } from '@/auth'
import { getToday } from '@/composables/useLunch'
import { RouteName } from '@/enums'
import { useAuthStore } from '@/stores/auth'

const auth = useAuthStore()
const router = useRouter()
const { t } = useI18n()

const items = computed<ANavigationItemInterface[]>(() => [
  { title: t('admin.dashboard.title'), to: { name: RouteName.ADMIN_DASHBOARD } },
  { title: t('admin.lunch preferences.lunch preferences'), to: { name: RouteName.ADMIN_DAY_PREFERENCES, params: { date: getToday() } } },
  // given as feedback not atm needed for lunchtool app
  // { title: t('admin.rounds.listTitle'), to: { name: RouteName.ADMIN_ROUNDS } },
  // { title: t('admin.caterers.title'),    to: { name: RouteName.ADMIN_CATERERS } },
  // { title: t('admin.productLists.title'), to: { name: RouteName.ADMIN_PRODUCT_LISTS } },
])

const productIcon = markRaw({
  setup: () => () => h(SandwichIcon, { class: 'size-5 text-foreground' }),
})

const product = computed<ANavigationProductsProperties>(() => ({
  title: 'Lunchtool',
  short: 'LT',
  component: productIcon,
  items: [],
}))

const profile = computed<ANavigationProfileInterface>(() => ({
  id: auth.user?.id,
  name: auth.user?.name,
  first_name: auth.user?.first_name,
  last_name: auth.user?.last_name,
  email: auth.user?.email,
  image: auth.user?.avatar,
  items: [
    // Configuration lives in the profile menu, not the top navigation (same as the other Atabase products).
    {
      title: t('admin.navigation.settings'),
      icon: SettingsIcon,
      to: { name: RouteName.ADMIN_OFFICES },
      visible: auth.isAdmin,
    },
    {
      title: t('admin.navigation.mobileView'),
      icon: SmartphoneIcon,
      click: () => router.push({ name: RouteName.HOME }),
    },
    { separator: true },
    {
      title: t('admin.navigation.logout'),
      icon: LogOutIcon,
      click: () => useAuthDriver().logout(),
    },
  ],
}))
</script>

<template>
  <div class="atabix-auth-layout">
    <ANavigation :items="items" :product="product" :profile="profile" title="Lunchtool" />
    <RouterView class="atabix-auth-layout__content" />
  </div>
</template>

<style lang="scss" scoped>
.atabix-auth-layout {
  @apply min-h-screen grow flex flex-col;
}

.atabix-auth-layout__content {
  @apply w-full h-full grow;
}
</style>
